import { isWeiXin } from './function'

const requestUrl = isWeiXin() ? location.pathname + 'api' : '/api';

export default {
  requestUrl
}
